import React from 'react'
import PropTypes from 'prop-types'
import { formatPrice } from 'Utils/inputUtils'
import {
  _PreconPricingContainer, _IncentivesContainer, _TitleValueBlock, _DepositText, _ContactCTA,
  _DepositStructureContainer, _PricingContainer, _Title, _IncentiveText, _PricingDepositContainer,
} from './styles'


export const formatFeeValue = (feeObject) => {
  switch(feeObject.type) {
    case 'Assignment Fee':
    case 'Parking':
    case 'Storage Cost':
    case 'Locker':
    case 'Lawyer':
    case 'Co-op/Realtor':
      if(
        feeObject?.numeric_value === 0
        || feeObject?.numeric_value === null
        || feeObject?.value === '0'
      ) return '-'
      return formatPrice(feeObject?.numeric_value || feeObject?.value)
    case 'Minimum Deposit':
      if(
        feeObject?.numeric_value === 0
        || feeObject?.numeric_value === null
        || feeObject?.value === '0'
      ) return '-'
      return `${feeObject?.numeric_value || feeObject?.value}%`
    case 'Maintenance':
    case 'Parking Maintenance':
    case 'Locker Maintenance':
      if(
        feeObject?.numeric_value === 0
        || feeObject?.numeric_value === null
      ) return '-'
      const price = formatPrice(feeObject?.numeric_value || feeObject?.value)
      return `${price} / sqft per month`
    case 'Development Levies':
    default:
      return feeObject.value
  }
}

export const PreconPricing = ({ fees, handleContactAgentClick, buildingName, isListingPage = false }) => {
  const depositStructure = []
  const feeCosts = fees && fees.filter(fee => {
    if(fee.type === 'Deposit Structure') {
      depositStructure.push(fee)
      return false
    }
    return true
  })

  return (
    <_PreconPricingContainer>
      <_PricingDepositContainer isListingPage={isListingPage}>
        <_PricingContainer isListingPage={isListingPage}>
          <_Title>Pre-con Pricing</_Title>
          {
            feeCosts?.length > 0 ? feeCosts?.map(fee => (
              <_TitleValueBlock
                key={fee?.type + fee?.value}
                title={fee?.type + ':'}
                value={(fee?.value || fee?.numeric_value) ? formatFeeValue(fee) : '-'}
              />
            )) : <_DepositText>Coming Soon</_DepositText>
          }
        </_PricingContainer>
        <_DepositStructureContainer isListingPage={isListingPage}>
          <_Title>Deposit Structure</_Title>
          {
            depositStructure.length > 0 ? depositStructure.map(dep => (
              <_DepositText dangerouslySetInnerHTML={{ __html: dep?.value }} />
            )) : <_DepositText>Coming Soon</_DepositText>
          }
        </_DepositStructureContainer>
      </_PricingDepositContainer>
      <_IncentivesContainer isListingPage={isListingPage}>
        <_Title>Incentives</_Title>
        <_IncentiveText>Contact our {buildingName || ''} building expert to learn about possible incentives.
        </_IncentiveText>
        <_ContactCTA onClick={handleContactAgentClick} primary>Contact</_ContactCTA>
      </_IncentivesContainer>
    </_PreconPricingContainer>
  )
}
PreconPricing.propTypes = {
  fees: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    value: PropTypes.string,
  })),
  handleContactAgentClick: PropTypes.func,
  buildingName: PropTypes.string,
  isListingPage: PropTypes.bool,
}

export default PreconPricing
